var map = {
	"./cj.png": 5978,
	"./gq.png": 9837,
	"./sr.png": 1966,
	"./tanmantang.svg": 8478,
	"./tanmantang2.svg": 4512,
	"./tanmantang_qianming.ai": 4212,
	"./zq.png": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;